export default [
  {
    path: "/F97MvJlLY58wQes61l2",
    children: [
      {
        path: "wsq3zxqV2302c",
        name: "myassigned_courses",
        meta: {
          title: "Assigned Subjects",
          authRequired: true,
          acc: ["y50732"],
        },
        component: () => import("@/views/assignedcourses/index.vue"),
      },

      {
        path: "cpFgstrRyER7LUB4B93/:level?",
        name: "myassignedCourseView",
        meta: {
          title: "View Assigned Subject",
          authRequired: true,
          acc: ["y80701"],
        },
        component: () => import("@/views/assignedcourses/view.vue"),
      },
    ],
  },
];
